import {Component, OnInit} from '@angular/core';
import {AbstractProfileValidator} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/base/abstract-profile-validator";
import {FormBuilder} from "@angular/forms";
import {EventProfileType} from "@biletix/core/common/enums/event-profile-type.enum";

@Component({
    standalone: false,
    selector: 'btx-membership-profile-validator',
    templateUrl: './membership-profile-validator.component.html',
    styleUrls: ['./membership-profile-validator.component.scss']
})
export class MembershipProfileValidatorComponent extends AbstractProfileValidator implements OnInit {

    isDiscountApplied: boolean = false;

    constructor(fb: FormBuilder) {
        super(fb);
    }

    ngOnInit(): void {
        this.initializeValidationFormGroup(this.validationFieldConfigs);
    }


    public validatorClasses() {
        return {
            'member-online': this.profile.profileType == EventProfileType.MEMBERONLINE,
            'member-default': this.profile.profileType == EventProfileType.MEMBER,
            'turkcell-member': this.profile.profileType == EventProfileType.TURKCELLMEMBER,
            'tck-member': this.profile.profileType == EventProfileType.TCKMEMBER,
        }
    }


    onValidateProfile() {
        if (this.validationFormGroup.invalid) {
            this.validationFormGroup.markAllAsTouched();
            return;
        }

        const validationFields: any[] = this.validationFormGroup.value;

        this.isDiscountApplied = !this.isDiscountApplied;
        //TODO: validate  profile
        //service call


    }

}
